<dxp-multi-selector [selectorId]="this.componentId" data-source-key-name="description" [items]="this.companyList"
    search-placeholder="{{msg.PlaceHolders.SelectOptions}}" placeholder="{{msg.PlaceHolders.SelectOptions}}"
    [label]="this.displayLabel" [optional]="this.isOptional" (selectedOptions)="setSelectedCompany($event)"
    multi-search="true" [maxLimit]="this.maxSelectionCount" [list-aria-label]="this.ariaText" [value]="this.selectedValue?.description" #companyListReference>
</dxp-multi-selector>
<span class="form-validation-error"
    *ngIf="!this.isOptional && this.submitted === 'enabled' && selectorControlName.errors && selectorControlName.errors['required']">
    {{msg.FormValidationMessage.companyRequired}}
</span>